import './Departamento.css';
import Footer from '../../components/Footer/Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faCircleArrowLeft } from '@fortawesome/free-solid-svg-icons';
import GoBackButton from '../../components/GoBackButton';
import { Component } from 'react';

class AcaoSocial extends Component {
    componentDidMount(){
        window.scrollTo(0, 0);
    }
    render(){
        return (
            <div className='departamento'>
                <div className="AcaoSocialHeader">
                    <GoBackButton></GoBackButton>
                </div>
                <div className="DepartamentoMain">
               <div id="introduçao">
                    <p>A AEFEUP, como a vemos, tem de ser uma associação próxima e tomar conhecimento dos
                        reais problemas e anseios dos estudantes, levando-os à direção da FEUP se necessário
                        para os resolver. A Lista E ambiciona que a FEUP seja, em simultâneo, uma faculdade
                        inclusiva. Para tal tem de se comprometer a criar ambientes adequados para pessoas com
                        dificuldades de locomoção, com visão reduzida ou perda total, ou parcial da mesma. Ainda
                        prevalecem os problemas arquitetónicos que dificultam o bem-estar destes estudantes na
                        faculdade, tais como: poucas rampas de acesso para cadeiras de rodas; edifícios dotados
                        de escassa sinalética; corredores muito escuros e escadas mal sinalizadas de modo a
                        serem distinguíveis. A Lista E compromete-se na apresentação destes mesmos problemas
                        à Direção da FEUP e com sugestões de adaptações que melhorariam a vida de um
                        estudante. Faltam também bebedouros, oferta mais diversificada de comida nas máquinas
                        da FEUP e mais espaços para comer como se verifica com a crescente sobrelotação de
                        todas as áreas de alimentação nas imediações da FEUP.
                    </p>
               </div>
              
                <div className="paragrafo">
                    <p>Como é hoje sabido, "O consumo de antidepressivos não para de aumentar com Portugal a
                        surgir em terceiro lugar na lista dos países desenvolvidos (da OCDE). Nos ansiolíticos, o
                        volume de vendas (...) coloca mesmo Portugal em primeiro lugar comparativamente com
                        todos os outros países da OCDE". Também é sabido que os portugueses que procuram ser
                        tratados no SNS não encontram resposta, uma vez que este possui meios insuficientes. Os
                        estudantes em particular, principalmente depois da pandemia e com o início do ensino à
                        distância, viram a sua saúde mental ser significativamente deteriorada, muitos deles
                        inclusive iniciaram medicação a ansiolíticos e antidepressivos. A depressão e ansiedade
                        são alguns dos muitos exemplos das doenças do foro mental que predominam ainda na
                        comunidade estudantil e a Lista E pretende encará-los com a urgência necessária,
                        apresentando medidas concretas para os combater. É imprescindível atender aos
                        estudantes que ingressaram na faculdade há pouco tempo, principalmente os deslocados,
                        confrontados com uma profunda mudança na sua vida ao verem-se de um momento para
                        o outro distantes dos familiares e amigos. Há que ter uma especial atenção com os
                        estudantes com dificuldades financeiras e com aqueles que, devido à pandemia e ao
                        ensino à distância, não puderam socializar, conhecer os colegas ou adaptar-se mais
                        facilmente.
                    </p>
                    <p>Ter um estilo de vida saudável é essencial para o bem-estar e bom aproveitamento dos
                        estudantes da FEUP. Devido à falta quer de informação generalizada, quer de experiência, os
                        jovens costumam tomar comportamentos de risco. Desde a condução ao uso de drogas,
                        da sexualidade à alimentação estes comportamentos podem trazer problemas de saúde
                        graves para os estudantes. Como tal, a AE tem de ter um papel ativo para combater estes
                        flagelos. Relevante também é promover o fornecimento de produtos de higiene mentrual de
                        forma gratuita, não só como meio de apoio aos custos inevitáveis e, para muitas,
                        incomportáveis dos mesmos, mas também como uma tomada de posição face a um
                        problema transversal.
                    </p>
                    <p>Segundo a comunidade científica, vivemos a cerca de 7 anos até ao ponto de não retorno
                        das alterações climáticas. É um tempo em que urge haver mudança nos nossos hábitos e
                        práticas quotidianas. A Lista E revê-se na necessidade mundial de lutar contra as
                        alterações climáticas. É urgente concretizar medidas concretas que contrariem este flagelo.
                        A Associação de Estudantes, para além de promover medidas individuais que propiciem
                        um meio ambiente salutar, deve fomentar medidas de ação coletiva para que os alunos e
                        futuros engenheiros estejam melhor informados dos problemas com que irão ter de lidar no
                        futuro, uma vez que a engenharia tem um importante papel a desempenhar no combate a
                        este flagelo.
                    </p>
                </div>
                <div className="container">
                   <div className="row">
                            <div className="col-sm">
                              <div>
                              <h2>Acessibilidade</h2>
                    
                                <p>A nível de acessibilidade pretendemos apresentar à FEUP:
                                    <ul>
                                        <li>Envolver a comunidade estudantil e docente na resolução dos problemas de
                                            acessibilidade nas faculdades, realizando inquéritos sobre a matéria;</li>
                                        <li>Nivelação dos pisos exteriores;</li>
                                        <li>Iluminação mais intensa nos corredores e escadas;</li>
                                        <li>Colocação de sinalética nas escadas;</li>
                                        <li>Colocação de sinalética mais legível e acessível nos corredores para identificação de
                                            locais, incluindo o nome das salas em braille, por exemplo.</li>
                                    </ul></p>
                                </div>
                            </div>
        
                            <div className="col-sm">
                                <div>
                                <h2>Ação Social</h2>
                                <p>Neste campo, propomos: 
                                <ul>
                                    <li>Recolha de roupa, alimentos, eletrónicos, brinquedos;</li>
                                    <li>Realização da feira de voluntariado;</li>
                                    <li>Realização do dia da cidadania.  </li>
                                </ul>  </p>                    
                                </div>
                            </div>
                    </div>
                </div>
                <div className="container">
                    <h2>Saúde Mental</h2>
                   <div className="row">
                            <div classNameName="col-sm">
                              <div>            
                                <p>Propostas a serem apresentadas à FEUP:
                                    <ul>
                                        <li>Facilitar o acesso e aumentar o número de profissionais afetos ao serviço;</li>
                                        <li>Fazer inquéritos aos alunos relativamente às consultas de psicologia da FEUP para
                                            melhor avaliar o seu desempenho;</li>
                                        <li>Insistir na divulgação destes serviços e de como colocá-los à distância de um clique
                                            por parte dos estudantes que dele necessitem.</li>
                                        
                                    </ul></p>
                                </div>
                            </div>
                            <div className="col-sm">
                                <div>
                                <p>Propostas a executar pela AEFEUP:  
                                <ul>
                                    <li>Promoção do setembro amarelo, mês de consciencialização da saúde mental, com
                                        criação de workshops de mindfulness e yoga;</li>
                                    <li>Realização de palestras sobre o tema, convidando profissionais e associações;</li>
                                    <li>Oferta de panfletos informativos sobre a possibilidade de atendimento oferecida pela
                                        faculdade, assim como promoção da tal pelas redes sociais;  </li>
                                    <li>Criar um espaço de partilha para estudantes com o apoio de um profissional de 
                                        saúde (psicólogo e/ou psiquiatra), realizar parceria com os Serviços de Ação Social da UP;</li>
                                </ul></p>                    
                                </div>
                            </div>
                    </div>
                </div>
                <div className="container">
                    <h2>Alimentação</h2>
                   <div className="row">
                            <div className="col-sm">
                              <div>            
                                <p>Propostas a serem apresentadas à FEUP:
                                    <ul>
                                        <li>Instalação de bebedouros pelo edifício B, possivelmente nas entradas das casas de banho;</li>
                                        <li>Criação de mais espaços para refeição, nomeadamente algum espaço não
                                            associado a algum bar, aberto para estudantes que trazem comida de casa;</li>
                                        <li>Pedir mais microondas para aquecer a comida no edifício B e departamentos.</li>  
                                    </ul></p>
                                </div>
                            </div>
                            <div className="col-sm">
                                <div>
                                <p>Propostas a executar pela AEFEUP: 
                                <ul>
                                    <li>Criação de um FEUP Veggie Day em parceria com restaurantes vegetarianos do Porto;</li>
                                    <li>Adição de opções veganas e vegetarianas nas máquinas de venda automática e bar da AEFEUP;</li>
                                    <li>Adição de opções para pessoas com restrições alimentares, por exemplo, celíacos ou intolerantes à lactose, nas máquinas e bar da AEFEUP;</li>
                                    <li>Disponibilizar mais micro-ondas na Associação de estudantes, sendo a sua limpeza assegurada pelo utilizador, 
                                        que tem à sua disposição material para tal;  </li>
                                    <li>Promover a criação de workshops de nutrição e de partilha de receitas saudáveis.;</li>
                                </ul></p>                      
                                </div>
                            </div>
                    </div>
                </div>
                <div className="container">
                    <h2>Ambiente</h2>
                   <div className="row">
                            <div className="col-sm">
                              <div>            
                                <p>Propostas a serem apresentadas à FEUP:
                                    <ul>
                                        <li>Disponibilizar mais cinzeiros;</li>
                                        <li>Colocar caixotes do lixo com separadores para reciclagem nas salas e garantir que
                                            os caixotes que existem permitam a correta separação dos resíduos;</li>
                                        <li>Instalação de máquinas de água filtrada na FEUP (por exemplo junto às máquinas de
                                            café já existentes);</li>  
                                        <li>Pugnar para que todos os anos seja realizado um relatório de sustentabilidade da FEUP.</li>
                                    </ul></p>
                                </div>
                            </div>
                            <div className="col-sm">
                                <div>
                                <p>Propostas a executar pela AEFEUP:
                                <ul>
                                    <li>Implantação da “Semana do Ambiente” - com palestras, conversas, partilha de
                                        informações;</li>
                                    <li>Promoção do uso de bicicletas e meios de transporte suaves (mais estacionamento
                                        para bicicletas);</li>
                                    <li>Pugnar para que todos os anos seja realizado um relatório de sustentabilidade da
                                        AEFEUP;</li>
                                    <li>Garantir uma mais estreita cooperação com o Comissariado de Sustentabilidade da
                                        FEUP; </li>
                                    <li>Criação de feiras de garagem e de oficinas de reparação de eletrodomésticos;</li>
                                    <li>Promover a criação de uma horta comunitária partilhada por todos os estudantes;</li>
                                    <li>Disponibilizar mais cinzeiros;</li>
                                    <li>Organizar com outras organizações caminhadas em parques/serras com guias para
                                        sensibilizar os estudantes sobre a importância da biodiversidade;</li>
                                    <li>Colocação de um oleão na FEUP;</li>
                                    <li>Negociar com a editorial para que haja a opção de fazer as impressões em papel reciclado;</li>
                                    <li>Negociar com a editorial a criação de um voucher para a compra de novas sebentas
                                        em troca da devolução de sebentas antigas;</li>
                                    <li>Garantir que sempre que possível os alunos e as lojas nas imediações da FEUP e da
                                        AEFEUP usem e-faturas;</li>
                                    <li>Criar e promover atividades de voluntariado para apanhar beatas, plantar árvores e
                                        outras atividades que visem promover um ambiente mais limpo.
                                    </li>
                                </ul></p>                       
                                </div>
                            </div>
                    </div>
                </div>
                <div className='paragrafo' id = "last">
                    <h2>Saúde Física</h2>
                    <p>Propostas a executar pela AEFEUP:
                    <ul>
                        <li>Oferta de material de higiene menstrual de forma gratuita, nas instalações da AEFEUP;</li>
                        <li>Disponibilização de preservativos gratuitos nas instalações da AEFEUP;</li>
                        <li>Campanhas de consciencialização sobre os efeitos nefastos do tabagismo e consumo excessivo de álcool;</li>
                        <li>Reafirmação da proibição de fumar em locais fechados, especificamente em FEUPcaffé’s;</li>
                        <li>Campanhas de consciencialização sobre saúde sexual com sexólogos sobre os mais variados temas e promoção de giveaways de brinquedos sexuais;</li>
                        <li>Criação de variados workshops sobre: problemas do foro urogenital (como por
                            exemplo, como infecções urinárias, pedras nos rins, infeções vaginais, incontinência
                            urinária, endometriose, ovários poliquísticos, disfunção eréctil, ejaculação precoce);
                            saúde feminina e ciclo menstrual saudável; métodos contraceptivos e sua eficácia,
                            riscos e benefícios; e doenças sexualmente transmissíveis;</li>
                        <li>Garantia de apoio psicológico e apoio à denúncia de abusos sexuais, violência no
                            namoro e discriminação sexual;
                        </li>
                        <li>Realização de ações de rastreio regular de Infeções Sexualmente Transmissíveis,
                            abertas à FEUP e toda a comunidade do Pólo da Asprela, em articulação com
                            autoridades de saúde e outras associações;
                        </li>
                        <li>Promoção de campanhas de doação de sangue;</li>
                        <li>Promoção de campanhas sobre alimentação saudável, articuladas com as medidas
                            de Alimentação;</li>
                        <li>Campanhas de esclarecimentos sobre os serviços médicos dos SASUP;</li>
                        <li>Criação de campanhas de esclarecimento sobre os benefícios do exercício e da saúde física.</li>
                    </ul></p>
                </div>
               
            
            </div>
            <button id='scrollToTopBtn' className='scrollToTopBtn'>
                <FontAwesomeIcon icon={faArrowUp} size="lg" />
            </button>
                        
            <Footer></Footer>
                
            </div>
          );
    }

}

export default AcaoSocial;
